import { trim } from 'lodash-es'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearErrorsFromServer as clearErrorsFromServerAction,
  loadCompanies as loadCompaniesAction,
  setEditCompanyModalVisibility as setEditCompanyModalVisibilityAction,
  setUpdatedSuccessModalVisibility as setUpdatedSuccessModalVisibilityAction,
  updateCompany as updateCompanyAction,
} from '../../slices/company_slice'
import CompanyFormModal from '../modals/CompanyFormModal'
import CompanyFormContent from './CompanyFormContent'
import SuccessModalContent from './SuccessModalContent'

export function EditCompany() {
  const { currentCompany, updatedSuccessModalVisibility, editCompanyModalVisibility } = useSelector(
    (state) => state.company
  )
  const dispatch = useDispatch()

  const handleSubmit = async (data) => {
    const formData = new FormData()
    const forms = {
      name: data.name,
      company_type: data.company_type,
    }

    Object.keys(forms).forEach((key) => {
      formData.append(`company[${key}]`, forms[key])
    })

    data.company_aliases_attributes.forEach((item) => {
      if (!!trim(item.name)) {
        if (item.id) {
          formData.append('company[company_aliases_attributes][][id]', item.id)
        }
        formData.append('company[company_aliases_attributes][][name]', item.name)
      }
    })

    if (data.company_logo?.length > 0) formData.append('company[logo]', data.company_logo[0])

    dispatch(updateCompanyAction({ data: formData, id: currentCompany.id }))
  }

  const onCloseCompanyFormModal = () => {
    dispatch(clearErrorsFromServerAction('edit'))
    dispatch(setEditCompanyModalVisibilityAction(false))
  }

  const onCloseUpdatedSuccessModal = () => {
    dispatch(loadCompaniesAction({ query: '*' }))
    dispatch(setUpdatedSuccessModalVisibilityAction(false))
  }

  return (
    <>
      <CompanyFormModal open={editCompanyModalVisibility}>
        <CompanyFormContent
          company={currentCompany}
          onBack={onCloseCompanyFormModal}
          onNext={handleSubmit}
          formId="companyForm-edit"
        />
      </CompanyFormModal>
      <CompanyFormModal open={updatedSuccessModalVisibility}>
        <SuccessModalContent title={`${currentCompany?.name} updated!`} onNext={onCloseUpdatedSuccessModal} />
      </CompanyFormModal>
    </>
  )
}
